import * as React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { useQueryErrorResetBoundary } from "react-query";
import { ConfigProvider as AppSettingsProvider } from "@sigeo-registry/config-react";
import { ErrorBoundary } from "react-error-boundary";

import config from "./config";
import { CirclelLoader } from "./components/loader";
import { getURLPathname } from "./helpers";
// import { Network } from './components/network';
import Error from "./components/errors/Error";
import NavProvider from "./helpers/Provider";
import OIDCProvider from "./components/OIDCProvider";
import CallbackPage from "./components/CallbackPage";
import AuthWrapper from "./components/AuthWrapper";

const App = React.lazy(() => import("./Main"));

type RootComponent = React.FC<{}>;

const Root: RootComponent = () => {
  const basename: string = getURLPathname(process.env.PUBLIC_URL);
  const { reset } = useQueryErrorResetBoundary();
  const stl: React.CSSProperties = { marginTop: "50vh" };
  
  return (
    <AppSettingsProvider config={config}>
      <OIDCProvider>
        {/* <QueryClientProvider client={queryClient}> */}
        <Router basename={basename}>
          <ErrorBoundary onReset={reset} FallbackComponent={Error}>
            <React.Suspense
              fallback={<CirclelLoader style={stl}>init app...</CirclelLoader>}
            >
              {/* <Network> */}
                <NavProvider>
                  <Switch>
                    <Route path="/callback">
                      <CallbackPage />
                    </Route>
                    <Route path="/*">
                      <AuthWrapper>
                        <App />
                      </AuthWrapper>
                    </Route>
                  </Switch>
                </NavProvider>
              {/* </Network> */}
            </React.Suspense>
          </ErrorBoundary>
        </Router>
        {/*  </QueryClientProvider> */}
      </OIDCProvider>
    </AppSettingsProvider>
  );
};

export default Root;
